<script setup lang="ts">
defineProps<{
    title: string;
}>();
</script>

<template>
    <div class="border-secondary overflow-hidden rounded-xl border">
        <div class="bg-secondary flex items-center justify-center py-2 font-semibold text-white">
            {{ title }}
        </div>
        <slot />
    </div>
</template>
